export default __webpack_public_path__ + "static/media/greenArrow.212edbd2.svg";